import React, { useEffect, useState } from 'react';
import Button from '../../../../../component/ui/Button';
import limitIcon from '../../../../../assets/image/subscription/limits-icon.svg';
import advFeatureIcon from '../../../../../assets/image/subscription/adv-feature-icon.svg';
import priorityIcon from '../../../../../assets/image/subscription/priority-support-icon.svg';
import safeSecureIcon from '../../../../../assets/image/subscription/safe-secure-icon.svg';
import checkIcon from '../../../../../assets/image/check_stock_icon.svg';
import CurrentPlanComponents from './componets/currentPlanComponents';
import PlanBenefit from './componets/planBenefit';
import SubscriptionStatisticsUsages from './componets/subscriptionStatisticsUsages';
import SubscriptionFeatures from './componets/subscriptionFeatures';
import CancelSubscriptionModel from './componets/cancelSubscriptionModel';
import CancelSubscriptionReasonModal from './componets/cancelSubscriptionReasonModal';
import ManageBilling from './manageBilling';
import CustomToastMessage from '../../../../components/customToastMessage';
import {
	getSubscriptions,
} from '../../../../../services/settings/subscriptions';
import PricingModal from '../../../../../component/PricingModal';
import UsageOverviewModal from './componets/usageOverviewModal';
import PageLoader from '../../../../../component/PageLoader';

export default function Subscription({ activeTab }) {
	const [isOpenUpgradeModal, setIsOpenUpgradeModal] = useState(false);
	const [isOpenCancelSubscriptionModal, setIsOpenCancelSubscriptionModal] = useState(false);
	const [isOpenReasonModal, setIsOpenReasonModal] = useState(false);
	const [isShowToast, setShowToast] = useState(false);
	const [isloadPlan, setIsLoadPlan] = useState(false);
	const [isOpenUsageOverviewModal, setIsOpenUsageOverviewModal] = useState(false);
	const [isloadSubscription, setIsLoadSubscription] = useState(false);
	const [subscriptionScreenType, setSubscriptionScreenType] = useState('subscription');
	const [planBenefit, setPlanBenefit] = useState([
		{
			icon: limitIcon,
			title: 'Higher Limits',
			description: 'Increase invoices, users, and storage as you grow.',
		},
		{
			icon: advFeatureIcon,
			title: 'Advanced Features',
			description: 'Unlock advanced reports, analytics, and automation.',
		},
		{
			icon: priorityIcon,
			title: 'Priority Support',
			description: 'Get faster response with priority support.',
		},
		{
			icon: safeSecureIcon,
			title: 'Safe & Secure',
			description: 'Your data is protected and backed up.',
		},
	]);
	const [subscriptionDetails, setSubscriptionDetails] = useState({});

	const getSubscriptionDetails = async () => {
		try {
			setIsLoadSubscription(true);
			const { subscription } = await getSubscriptions();
			setSubscriptionDetails(subscription);
		} catch (error) {
		} finally {
			setIsLoadSubscription(false);
		}
	};

	useEffect(() => {
		getSubscriptionDetails();
	}, []);

	const showMessage = () => {
		setShowToast(true);
		setTimeout(() => {
			setShowToast(false);
		}, 3000);
	};


	return isloadSubscription ? <PageLoader /> : subscriptionScreenType === 'subscription' ? (
		<div>
			<PricingModal isOpen={isOpenUpgradeModal} handleClose={() => setIsOpenUpgradeModal(false)} />
			<div style={{ backgroundColor: '#EDEDF7', position: 'sticky', top: 0, zIndex: 100 }}>
				<div className="d-flex py-3 px-2 justify-content-between align-items-center">
					<div className="fs-3 fw-bold">{'Subscription & Billing'}</div>
					<div className="d-flex gap-3 px-3">
						<Button
							type="button"
							className="mt-0 btn-primary fs-5 fw-light add-pro py-1"
							button="Upgrade"
							onClick={() => setIsOpenUpgradeModal(true)}
						/>
					</div>
				</div>
			</div>
			<div style={{ height: 'calc(100vh - 120px)', overflowX: 'auto', overflowY: 'auto' }}>
				<div className="p-3">
					<CurrentPlanComponents
						currentPlan={subscriptionDetails}
						setIsOpenCancelSubscriptionModal={setIsOpenCancelSubscriptionModal}
						setSubscriptionScreenType={setSubscriptionScreenType}
					/>
					<SubscriptionStatisticsUsages planUsages={subscriptionDetails.plan_usages} setIsOpenUsageOverviewModal={setIsOpenUsageOverviewModal} />
					<PlanBenefit benefits={planBenefit} />
					<SubscriptionFeatures
						features={subscriptionDetails?.features}
						loader={isloadPlan}
					/>
				</div>
			</div>
			{isOpenCancelSubscriptionModal && (
				<CancelSubscriptionModel
					isOpenModal={isOpenCancelSubscriptionModal}
					setIsOpenModal={setIsOpenCancelSubscriptionModal}
					setIsOpenReasonModal={setIsOpenReasonModal}
				/>
			)}
			{isOpenUsageOverviewModal && (
				<UsageOverviewModal
					isOpenModal={isOpenUsageOverviewModal}
					setIsOpenModal={setIsOpenUsageOverviewModal}
					planType={subscriptionDetails?.plan?.name}
					setIsOpenUpgradeModal={setIsOpenUpgradeModal}
				/>
			)}

			{isOpenReasonModal && (
				<CancelSubscriptionReasonModal
					isOpenModal={isOpenReasonModal}
					setIsOpenModal={setIsOpenReasonModal}
					showMessage={showMessage}
					onCancelSuccess={() => {
						getSubscriptionDetails(); // refresh subscription data in parent
					}}
				/>
			)}
			{isShowToast && (
				<CustomToastMessage
					icon={checkIcon}
					title={'Subscription cancelled successfully'}
					description={
						'You can continue using Pharmnex till your current plan ends. You will have 30 days after expiry to export your data or renew your subscription.'
					}
				/>
			)}
		</div>
	) : subscriptionScreenType === 'manage-billing' ? (
		<div style={{ height: 'calc(100vh - 80px)', overflowX: 'hidden', overflowY: 'auto' }}>
			<ManageBilling setSubscriptionScreenType={setSubscriptionScreenType} />
		</div>
	) : (
		<></>
	);
}
